import dp from '../assets/png/my.jpg'
export const headerData = {
    name: 'Bhavyashree K P',
    title: "Hello! I am",
    desciption: "Hello! I'm Bhavyashree K P, a passionate MERN stack developer specializing in MongoDB, Express.js, React.js, and Node.js. I thrive in fast-paced environments, enjoy tackling new challenges, and delivering thoughtful, scalable solutions. Driven by curiosity, I continually learn new technologies to expand my skill set and create meaningful, high-impact web applications.",
    image: dp,
    // imagebw: 'https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg',
    resumePdf: 'https://drive.google.com/file/d/12-0SzE8dU2V3WFk9qagePmkqvNPP9pkB/view?usp=sharing'
}
